import { render } from "./FeaturedPlacesSection.vue?vue&type=template&id=5d167904&scoped=true"
import script from "./FeaturedPlacesSection.vue?vue&type=script&lang=js"
export * from "./FeaturedPlacesSection.vue?vue&type=script&lang=js"

import "./FeaturedPlacesSection.vue?vue&type=style&index=0&id=5d167904&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d167904"]])

export default __exports__